var generateStyle = function generateStyle(componentTheme) {
  return {
    page: {
      backgroundColor: componentTheme.pageBackgroundColor
    },
    startTime: {
      padding: componentTheme.startTimePadding
    },
    endTime: {
      padding: componentTheme.endTimePadding
    }
  };
};
export default generateStyle;